import { useEffect } from "react";
import useAZZKUVoivodeships from "hooks/AZZKU/useAZZKUVoivodeships";
import useAZZKUAvailableTerritories from "hooks/AZZKU/useAZZKUAvailableTerritories";

import CheckboxGroup from "components/CheckboxGroup";
import Options from "components/Options";
import Select from "components/Select";
import Loader from "components/Loader";

export default function TerritorialScaleChoose({ in_sidebar, params, errors, onChange }) {

   const { d: available_territories } = useAZZKUAvailableTerritories( params.variable_id, params.relation_id );
   const { d: voivodeships } = useAZZKUVoivodeships();

   useEffect(() => {
      if ( !available_territories || available_territories.length === 2 ) return;

      const new_available_territory = available_territories[0] === "country" ? 1 : 2;
      if ( params.territorial_scale === new_available_territory ) return;

      onChange({
         territorial_scale: new_available_territory,
         voivodeship_ids: []
      });
   }, [ available_territories ])

   return voivodeships && available_territories ? (
      <>
         { !in_sidebar &&
            <> 
               <p> Wybierz obszar, dla którego chcesz wygenerować raport: </p>

               <Options
                  name="territorial_scale"
                  value={ params.territorial_scale }
                  disabled={ available_territories.length === 1 }
                  extra_classes={ available_territories.length === 1 ? "disabled" : "" }
                  options={[
                     { value: 1, label: "Polska" },
                     { value: 2, label: "Województwa" }
                  ]}
                  onChange={( n, v ) => onChange({
                     [n]: v,
                     voivodeship_ids: []
                  })}
               />
            </>
         }

         { in_sidebar &&
            <Select
               name="territorial_scale"
               value={ params.territorial_scale }
               disabled={ available_territories.length === 1 }
               ariaLabel="Wybierz terytorium z listy rozwijanej"
               options={[
                  { value: 1, label: "Polska" },
                  { value: 2, label: "Województwa" }
               ]}
               onChange={( n, v ) => onChange({
                  [n]: v,
                  voivodeship_ids: []
               })}
            />
         }

         { available_territories.length === 1 && available_territories[0] === "country" && 
            <div> Wyniki występują jedynie w skali krajowej </div>
         }

         { +params.territorial_scale === 2 &&
            <>
               <p> Wybierz maksymalnie 4 województwa do porównania: </p>

               <CheckboxGroup
                  name="voivodeship_ids"
                  value={ params.voivodeship_ids || []}
                  errors={ errors?.voivodeship_ids }
                  buttons={ voivodeships }
                  max={4}
                  onChange={ onChange }
               />
            </>
         }
      </>
   ) : <Loader/>
}